<template>
  <div class="box">
    <form class="section" method="post" @submit.prevent="submitData()">
      <h1 class="title is-1">Welcome to JPCC</h1>
      <div class="field">
        <label class="label">Services</label>
        <div class="control">
          <select :class="{'input': true, 'is-danger': errors.has('service')}" v-model="selected_service">
            <option value="">Select your service</option>
            <option v-for="(services_row, index) in services_list" :key="index" :value="services_row.id">{{services_row.title}}</option>
          </select>
        </div>
        <span class="help is-danger" v-show="errors.has('service')" v-text="errors.first('service')"></span>
      </div>
      <div class="field">
        <label class="label">New People / Visior / New Christian</label>
        <div class="control">
          <label :class="{'radio': true, 'is-danger': errors.has('type')}" v-for="(new_people_type_row, index) in new_people_type_list" :key="index">
            <input type="radio" name="type" :value="new_people_type_row.id" v-model="type"> {{new_people_type_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('type')" v-text="errors.first('type')"></span>
      </div>
      <div class="field">
        <label class="label">Number of people</label>
        <div class="control">
          <input type="number" min="1" :class="{'input': true, 'is-danger': errors.has('quantity')}" v-model="quantity" value="1" placeholder="How many people">
        </div>
        <span class="help is-danger" v-show="errors.has('quantity')" v-text="errors.first('quantity')"></span>
      </div>
      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('name')}" v-model="name" placeholder="Your name...">
        </div>
        <span class="help is-danger" v-show="errors.has('name')" v-text="errors.first('name')"></span>
      </div>
      <div class="field">
        <label class="label">Gender</label>
        <div class="control">
          <label :class="{'radio': true, 'is-danger': errors.has('gender')}" v-for="(gender_row, index) in gender_list" :key="index">
            <input type="radio" name="gender" :value="gender_row.id" v-model="gender"> {{gender_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('gender')" v-text="errors.first('gender')"></span>
      </div>
      <div class="field">
        <label class="label">Birthday</label>
        <div class="control">
          <input type="date" :class="{'input': true, 'is-danger': errors.has('birth_date')}" v-model="birth_date" placeholder="Your birthday...">
        </div>
        <span class="help is-danger" v-show="errors.has('birth_date')" v-text="errors.first('birth_date')"></span>
      </div>
      <div class="field">
        <label class="label">Phone</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('phone')}" v-model="phone" placeholder="Your phone...">
        </div>
        <span class="help is-danger" v-show="errors.has('phone')" v-text="errors.first('phone')"></span>
      </div>
      <div class="field">
        <label class="label">Email</label>
        <div class="control">
          <input type="email" :class="{'input': true, 'is-danger': errors.has('email')}" v-model="email" placeholder="Your email...">
        </div>
        <span class="help is-danger" v-show="errors.has('email')" v-text="errors.first('email')"></span>
      </div>
      <div class="field">
        <label class="label">Apakah Anda saat ini sudah menjadi jemaat di gereja lain?</label>
        <span>Do you currently attend another church?</span>
        <div class="control">
          <label :class="{'radio': true, 'is-danger': errors.has('attend_other_church')}" v-for="(yes_no_row, index) in yes_no_list" :key="index">
            <input type="radio" name="attend_other_church" :value="yes_no_row.id" v-model="attend_other_church"> {{yes_no_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('attend_other_church')" v-text="errors.first('attend_other_church')"></span>
      </div>
      <div class="field">
        <label class="label">Apakah Anda ingin menjadikan JPCC sebagai gereja lokal Anda?</label>
        <span>Would you like to choose JPCC as your home church?</span>
        <div class="control">
          <label :class="{'radio': true, 'is-danger': errors.has('local_church')}" v-for="(yes_no_row, index) in yes_no_list" :key="index">
            <input type="radio" name="local_church" :value="yes_no_row.id" v-model="local_church"> {{yes_no_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('local_church')" v-text="errors.first('local_church')"></span>
      </div>
      <div class="field">
        <label class="label">Apakah Anda bersedia dihubungi lebih lanjut?</label>
        <span>Are you willing to be contacted for follow-up?</span>
        <div class="control">
          <label :class="{'radio': true, 'is-danger': errors.has('follow_up')}" v-for="(yes_no_row, index) in yes_no_list" :key="index">
            <input type="radio" name="follow_up" :value="yes_no_row.id" v-model="follow_up"> {{yes_no_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('follow_up')" v-text="errors.first('follow_up')"></span>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="submit" class="button is-link">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selected_service: '',
      type: '',
      quantity: 1,
      name: '',
      gender: '',
      birth_date: '',
      phone: '',
      email: '',
      attend_other_church: '',
      local_church: '',
      follow_up: '',
      new_people_type_list: [],
      gender_list: [],
      yes_no_list: [
        {
          id: 1,
          title: 'Yes'
        },
        {
          id: 0,
          title: 'No'
        }
      ],
      services_list: []
    }
  },
  created () {
    this.getGender()
    this.getType()
    this.getServices()
  },
  methods: {
    getGender () {
      var self = this
      self.flyGet('new_people/get_gender')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.gender_list = response.data.data
          self.gender = self.gender_list[0].id
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getType () {
      var self = this
      self.flyGet('new_people/get_type')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.new_people_type_list = response.data.data
          self.type = self.new_people_type_list[0].id
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getServices () {
      var self = this
      self.flyGet('new_people/get_services')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.services_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.flyPost('new_people', {
        service: this.selected_service,
        type: this.type,
        quantity: this.quantity,
        name: this.name,
        birth_date: this.birth_date,
        gender: this.gender,
        phone: this.phone,
        email: this.email,
        attend_other_church: this.attend_other_church,
        local_church: this.local_church,
        follow_up: this.follow_up
      })
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.$geb.emit({id: 'alert_modal', title: 'Thank You!', content: 'Terima kasih telah datang ke JPCC. Tuhan memberkati.', button_text: 'OK'})
          self.type = self.new_people_type_list[0].id
          self.quantity = 1
          self.name = ''
          self.birth_date = ''
          self.gender = self.gender_list[0].id
          self.phone = ''
          self.email = ''
          self.attend_other_church = ''
          self.local_church = ''
          self.follow_up = ''
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
          self.$geb.emit({id: 'alert_modal', title: 'Oops...', content: 'Ada data yang belum selesai di isi. Silahkan di cek kembali form yang anda isi', button_text: 'OK'})
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/floorarea/NewPeople.vue